import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BankAccountFormatDirective } from './bank-account-format.directive';



@NgModule({
	declarations: [
		BankAccountFormatDirective
	],
	imports: [
		CommonModule
	],
	exports: [
		BankAccountFormatDirective
	]
})
export class BankAccountFormatDirectiveModule { }
